export const MapConfig = {
  zoom: 2,
  center: [12, 64],

  inernwebMapExtent: {
    xmin: -915020.1799341175,
    ymin: 6373074.350009031,
    xmax: 1564024.778155799,
    ymax: 7833407.937342872,
    spatialReference: {
      wkid: 32633,
    },
  },

  kundewebMapExtent: {
    xmin: -392943.35479620297,
    ymin: 6363722.055130746,
    xmax: 1137833.0400899202,
    ymax: 7918882.498784967,
    spatialReference: {
      wkid: 32633,
    },
  },

  vectorTileLayerUrl:
    "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheBasis_WGS84/VectorTileServer/",

  //map services url
  kspuLayerUrl:
    "https://gisserver.puma.qa.posten.no/portal/sharing/servers/d14a90b460594b0e95644988e584d58a/rest/services/KSPU/MapServer",

  kundewebLayerUrl:
    "https://gisserver.puma.qa.posten.no/portal/sharing/servers/486e8c3ff86f403397d0da9411dd06b6/rest/services/Pumakundeweb/MapServer",

  geoKodingUrl:
    "https://gisserver.puma.qa.posten.no/portal/sharing/servers/6c2f541d0fab41669cb390d4cc8d30d1/rest/services/Geokoding/GeocodeServer",

  geoSokUrl:
    "https://gisserver.puma.qa.posten.no/portal/sharing/servers/6c2f541d0fab41669cb390d4cc8d30d1/rest/services/Geokoding/GeocodeServer",

  driveTimeAnalysisUrl:
    "https://gisserver.puma.qa.posten.no/portal/sharing/servers/95c83d20671f4208a5d1429c7e7a81c0/rest/services/DriveTime/GPServer",

  oldUtvalgGeometryUrl:
    "https://gisserver.puma.qa.posten.no/portal/sharing/servers/abffdaf08bcf4d39aed8f3cdb651ce26/rest/services/OldUtvalgGeometry/MapServer/0",

  budruterOutField: [
    "reolnavn",
    "reolnr",
    "beskrivelse",
    "kommentar",
    "reol_id",
    "kommuneid",
    "kommune",
    "fylkeid",
    "fylke",
    "teamnr",
    "teamnavn",
    "postnr",
    "poststed",
    "segment",
    "hh",
    "hh_res",
    "gb",
    "gb_res",
    "er",
    "er_res",
    "vh",
    "p_hh_u_res",
    "np_hh_u_res",
    "p_vh_u_res",
    "np_vh_u_res",
    "prissone",
    "reoltype",
    "pbkontnavn",
    "prsnr",
    "prsnavn",
    "prsbeskrivelse",
    "rutedistfreq",
    "sondagflag",
  ],
};
